/**
 * Raw API access for the sync layer. Bypasses src/services/db/router.js to
 * avoid a routing loop when push.js needs to actually hit the network for
 * the create/update/delete that the queue just popped.
 */

import { API, Auth } from 'aws-amplify';
import { withTimeout, getCachedIdToken } from '../network';

const API_NAME = 'babytrackApi';
const SESSION_TIMEOUT_MS = 4000;
const REQUEST_TIMEOUT_MS = 12000;

async function authHeaders() {
  try {
    const s = await withTimeout(Auth.currentSession(), SESSION_TIMEOUT_MS);
    return { Authorization: s.getIdToken().getJwtToken() };
  } catch {
    // See api/client.js getAuthHeaders — sending {} on Capacitor turns a slow
    // session lookup into a 401 → "Network Error", silently dropping queue
    // pushes. Fall back to the cached idToken so the drain keeps working.
    const cachedIdToken = getCachedIdToken();
    if (cachedIdToken) return { Authorization: cachedIdToken };
    return {};
  }
}

export async function rawGet(path, queryParams = {}) {
  const headers = await authHeaders();
  return withTimeout(
    API.get(API_NAME, path, { headers, queryStringParameters: queryParams }),
    REQUEST_TIMEOUT_MS
  );
}

export async function rawPost(path, body = {}) {
  const headers = await authHeaders();
  return withTimeout(
    API.post(API_NAME, path, { headers, body }),
    REQUEST_TIMEOUT_MS
  );
}

export async function rawPut(path, body = {}) {
  const headers = await authHeaders();
  return withTimeout(
    API.put(API_NAME, path, { headers, body }),
    REQUEST_TIMEOUT_MS
  );
}

export async function rawDelete(path) {
  const headers = await authHeaders();
  return withTimeout(
    API.del(API_NAME, path, { headers }),
    REQUEST_TIMEOUT_MS
  );
}
